import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  id: "Carousel",
  class: "row",
  style: {"position":"relative"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "placeholder.gif",
  width: "671",
  height: "425"
}, null, -1)
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "whatsapp.png",
  style: {"height":"50px"}
}, null, -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "h1 text-center fw-bold" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("a", {
          href: _ctx.whatsappNumber,
          target: "_blank",
          color: "#4dc247",
          id: "",
          class: "h2 q8c6tt-0 jmDuqF overlayed-image justify-content-center"
        }, [
          _createTextVNode("Message on Whatsapp "),
          _hoisted_5
        ], 8, _hoisted_4)
      ]),
      (!_ctx.C_Stppd)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "bg-danger text-white",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.C_Stp && _ctx.C_Stp(...args)))
            }, " Stop Slide Show ")
          ]))
        : _createCommentVNode("", true),
      (_ctx.C_Stppd)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "bg-success text-white",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.C_Rstrt && _ctx.C_Rstrt(...args)))
            }, " Run Slide Show ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("img", {
        src: _ctx.companyIconFileName,
        class: "d-inline-block align-text-bottom",
        "border-color": "red",
        width: "65",
        height: "65"
      }, null, 8, _hoisted_9),
      _createTextVNode(" " + _toDisplayString(_ctx.compnayName), 1)
    ])
  ], 64))
}